import { SAFacets } from 'types/SearchProvider'
import { ConstructorFacetSdkResponse } from '../../constructorTypes'

export const transformConstructorFacetsToFilters = (
  facetsParams: ConstructorFacetSdkResponse
): SAFacets => {
  return facetsParams.reduce((acc, { name, options }) => {
    acc[name] = (options || []).map(({ display_name, value, count }) => ({
      label: display_name,
      value: value,
      count: count,
    }))

    return acc
  }, {} as SAFacets)
}
